import { useFeatureFlagOverrideStore } from "@/utils/featureFlagOverride";
import { createSiteAllowlistFlag } from "@/utils/siteAllowlistFlag";

export const NOTIFICATIONS_FLAG_KEY = "VITE_FF_NOTIFICATIONS";

const notificationsEnvValue = import.meta.env.VITE_FF_NOTIFICATIONS === "true";

const notificationsSiteCheck = createSiteAllowlistFlag(
  import.meta.env.VITE_FF_NOTIFICATIONS,
  import.meta.env.VITE_FF_NOTIFICATIONS_SITES,
);

const composeNotificationsFlag = (
  override: boolean | undefined,
  siteId: string | undefined,
) => override ?? (notificationsEnvValue || notificationsSiteCheck(siteId));

export const isNotificationsEnabledForSite = (siteId: string | undefined) =>
  composeNotificationsFlag(
    useFeatureFlagOverrideStore.getState().overrides[NOTIFICATIONS_FLAG_KEY],
    siteId,
  );

export const useIsNotificationsEnabledForSite = (
  siteId: string | undefined,
) => {
  const override = useFeatureFlagOverrideStore(
    (s) => s.overrides[NOTIFICATIONS_FLAG_KEY],
  );
  return composeNotificationsFlag(override, siteId);
};
